function filterLogo(newFilter) {
  "use strict";

  var filterList = [];
  var selectedFilters = "";
  var numberFilters;

  if (newFilter !== undefined) {
    if (newFilter === null) {
      // Get values of checkboxes and stuff into aray
      jQuery(':checkbox:checked').each(function (i) {
        filterList[i] = jQuery(this).val();
      });
    } else {
      filterList[0] = newFilter;
    }

    numberFilters = filterList.length;

    for (var i = 0; i < numberFilters; i++) {
      selectedFilters += "." + filterList[i];
    } // Hide previous results of filtering


    jQuery(".logo-filter").hide(); // Apply filtering and show results

    jQuery(selectedFilters).show();
    jQuery("html.aem-AuthorLayer-Edit .logo-filter").show();

    if (numberFilters == 0) {
      jQuery(".logo-filter").hide();
      jQuery(".logo-filter.show").show();
      jQuery("html.aem-AuthorLayer-Edit .logo-filter").show();
    }
  }
}

function addLogoCheckbox(filterValue, filterContainer, filterText, filterSelect) {
  "use strict";

  jQuery("#showMore").show();

  if (filterValue != "") {
    var labelValue = 'label-' + filterValue;
    var labelID = '#' + labelValue;
    var labelCount = jQuery(labelID).length;

    if (labelCount == 0) {
      var checkboxText = '<label id="' + labelValue + '"><input type="checkbox" checked id="filter-' + filterValue + '" class="filter-checkbox" value="' + filterValue + '">' + filterText + '</label>';
      jQuery(filterContainer).append(checkboxText);
    }

    filterLogo(null);
    jQuery(filterSelect).val("").prop('selected', false);
  }
}

jQuery(document).ready(function () {
  "use strict"; // Define the IDs used on the form elements

  var filterCompany = '#logoCompany';
  var filterType = '#logoType';
  var filterProducts = '#logoProducts';
  var containerCompany = '#companyLogoContainer';
  var containerType = '#typeLogoContainer';
  var containerProducts = '#productsLogoContainer';
  jQuery(filterCompany).on('input', function () {
    var company = jQuery(filterCompany).val();
    var selectedCompany = $('#logoDatalist [value="' + company + '"]').data('company'); // Set Type to none

    jQuery(containerType).empty();
    jQuery(filterType).val("").prop('selected', false); // Set Products checkbox to none

    jQuery(containerProducts).empty();
    jQuery(filterProducts).val("").prop('selected', false);
    jQuery(containerCompany).empty();

    if (selectedCompany !== "") {
      filterLogo(selectedCompany);
    }
  }).trigger('input');
  jQuery(filterType).change(function () {
    var selectedType = jQuery(this).val();
    var textType = jQuery(filterType + " option:selected").text();
    jQuery(".logo-filter").hide(); // Set Company to none

    jQuery(filterCompany).val(""); // Set Type checkbox to none

    jQuery(containerType).empty();
    addLogoCheckbox(selectedType, containerType, textType, filterType);
  });
  jQuery(filterProducts).change(function () {
    var selectedProducts = jQuery(this).val();
    var textProducts = jQuery(filterProducts + " option:selected").text();
    jQuery(".logo-filter").hide(); // Set Company to none

    jQuery(filterCompany).val(""); // Set Products checkbox to none

    addLogoCheckbox(selectedProducts, containerProducts, textProducts, filterProducts);
  });
  jQuery('.c54').on("click", 'input:checkbox', function () {
    filterLogo(null);
  });
  jQuery("#showMore").click(function () {
    jQuery(".logo-filter").show();
    jQuery("#showMore").hide();
    jQuery(containerCompany).empty();
    jQuery(containerType).empty();
    jQuery(containerProducts).empty();
  }); // Hide all logos, then show the first 15...

  jQuery(".logo-filter").hide();
  jQuery('.logo-filter').slice(0, 15).addClass('show');
  jQuery(".logo-filter.show").show();
  jQuery(".aem-AuthorLayer-Edit .logo-filter").show();
});